import {TenantConstant} from '@models/dashboard/tenant-constants';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';
import {
  StatusEventSignalValueParsingType
} from '@constants/machine/status-event-signal/status-event-signal-value-parsing-type.enum';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {SignalMode} from '@constants/administration/machine/signal-mode.enum';

export class Signal {
  id: number;
  table: string;
  signal: string;
  scale: number;
  label: string;
  name: string;
  unit: string;
  type: string;
  protect: boolean;
  signalUsed: boolean;
  streamToBigQuery: boolean;
  calculated: boolean;
  isTriggerSignal: boolean;
  isErrorWord: boolean;
  decimals: number;
  signalColor: string;
  parentId: number;
  isByteArray: boolean;
  formula: any;
  isStatusSignal: boolean;
  signals: any;
  isParentForStatusSignal: boolean;
  usedInTriggers: any;
  mapping: any;
  value: any;
  alias: any;
  tenantConstants: TenantConstant[];
  parent: any;
  statusEventsDetails: StatusEventSignalEventsDetails;
  mode: SignalMode = SignalMode.NULLABLE;
  writable: boolean = false;
  minWritableValue: number | null = null;
  maxWritableValue: number | null = null;

  //used in ng-select to disable item
  disabled: boolean = false;

  constructor(signal: string, label: string, name: string, type: string) {
    this.signal = signal;
    this.label = label;
    this.name = name;
    this.type = type;
    this.id = 0;
    this.table = '';
    this.scale = 0;
    this.unit = '';
    this.protect = false;
    this.signalUsed = false;
    this.streamToBigQuery = false;
    this.calculated = false;
    this.isTriggerSignal = false;
    this.isErrorWord = false;
    this.decimals = 0;
    this.signalColor = '';
    this.parentId = 0;
    this.isByteArray = false;
    this.isStatusSignal = false;
    this.isParentForStatusSignal = false;
    this.tenantConstants = new Array<TenantConstant>();
    this.statusEventsDetails = new StatusEventSignalEventsDetails(0, name, label, '', StatusEventSignalValueParsingType.VALUE, new Map<string, StatusEventDetails>(), 0);
    this.mode = SignalMode.NULLABLE;
  }
}
